
/**
 * EDTools - for use with Eyedogz
 */

export function EDLog(value) {
    console.log('ED: ' + value);
}

export function EDLogObj(info, value) {
    console.log('ED: ' + info);
    console.log(value);
}

export function EDMakeAgentMap() {
    return new Map();
}

export function EDMakeQueueMap() {
    return new Map();
}

export function EDMakeEmptyContactHistory() {
    return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
} 

export function EDProcessContactHistory(contactHistoryV) {
    var idx = 0;
    var retHistory = new Map();
    for (idx = 0; idx < contactHistoryV.length; idx++) {
        var currHistory = contactHistoryV[idx];
        if (currHistory.hasOwnProperty('queueId')) {
            var timeDim = 0;
            try {
                var splitV = currHistory.timeCategory.split(' ')[1];
                timeDim = parseInt(splitV);
            }
            catch (e) {
                console.log('Exception process contact history: ' + e.Message);
                timeDim = 0;
            }
            var newTuple = [timeDim, currHistory.countOfArrivedContacts];

            if (retHistory.has(currHistory.queueId)) {
                var existingEntry = retHistory.get(currHistory.queueId);
                existingEntry.push(newTuple);
                retHistory.set(currHistory.queueId, existingEntry);            
            }
            else {
                var newEntry = [];               
                newEntry.push(newTuple);
                retHistory.set(currHistory.queueId, newEntry);
            }            
        }
    }

    return retHistory;
}

export function EDMakeContactHistoryArray(contactHistoryMapV, queueId) {
    var retVal = EDMakeEmptyContactHistory();
    var startNumber = 5;
    try {
        if (contactHistoryMapV.has(queueId)) {
            var existingEntry = contactHistoryMapV.get(queueId);
            var idx = 0;
            for (idx = 0; idx <= existingEntry.length; idx++) {
                retVal[(existingEntry[idx][0] - startNumber)] = existingEntry[idx][1];
            }
        }
    }
    catch (e) {
        console.log('EDMakeContactHistoryArray. Exception: ' + e.Message);
    }
    return retVal;
}

export function EDSubscribeAgent(agentMapV, agentId, agentInfo) {
    var currAgent = EDMakeEmptyAgentData();
    currAgent.agentSubscribeData = agentInfo;
    currAgent.id = agentId;
    currAgent.name = agentInfo.fullName;
    currAgent.avatarName = EDMakeAvatarName(agentInfo.fullName);
    agentMapV.set(agentId, currAgent);
    return agentMapV;
}

export function EDSubscribeVQueue(vQueueMapV, vQueueId, queueInfo) {
    var currVQueue = EDMakeEmptyQueueData(true);
    currVQueue.id = vQueueId;
    currVQueue.subscribeData = queueInfo;

    vQueueMapV.set(vQueueId, currVQueue);

    var idx = 0;
    // reverse map to find the vQueue
    for (idx = 0; idx < queueInfo.esQueues.length; idx++) {
        var currVQueueE = EDMakeEmptyQueueData(true);
        currVQueueE.id = vQueueId;
        currVQueueE.subscribeData = queueInfo.esQueues[idx];
        vQueueMapV.set(queueInfo.esQueues[idx], currVQueueE);
    }
    return vQueueMapV;
}

export function EDSubscribeVQueueQueues(queueMapV, vQueueId, queueInfo) {
    var idx = 0;
    // reverse map to find the vQueue
    for (idx = 0; idx < queueInfo.esQueues.length; idx++) {
        var currVQueue = EDMakeEmptyQueueData(true);
        currVQueue.id = vQueueId;
        currVQueue.subscribeData = queueInfo.esQueues[idx];
        queueMapV.set(queueInfo.esQueues[idx], currVQueue);
    }
     
    return queueMapV;
} 

export function EDSubscribeQueue(queueMap, queueId, queueInfo) {
    var currQueue = EDMakeEmptyQueueData(false);
    currQueue.id = queueId;
    currQueue.subscribeData = queueInfo;
    queueMap.set(queueId, currQueue);
    return queueMap;
}

export function EDVQueueZeroData(vQueueMapV) {
    var retVQueueMapV = new Map();
    for (let [key, value] of vQueueMapV) {
        console.log('EDVQueueZeroData: ' + key);
        var vQueueV = EDResetQueueData(value);
        retVQueueMapV.set(key, vQueueV);
    } 
    return retVQueueMapV;
}

export function EDVAgentZeroData(vAgentMap) {
    var retVAgentMap = new Map();
    for (let [key, value] of vAgentMap) { 
        var vAgent = EDResetAgentData(value);
        retVAgentMap.set(key, vAgent);
    }
    return retVAgentMap;
}

export function EDQueueGetNumInQueue(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).numInQueue;
    }

    return retVal;
}

export function EDQueueGetLongestWaitTimeInQueue(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = EDMakeTimeString(vQueueMapV.get(queueId).longestWaitingInSeconds);
    }

    return retVal;
}

export function EDQueueGetLongestWaitTimeInQueueSeconds(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).longestWaitingInSeconds;
    }

    return retVal;
}


export function EDQueueGetNumAgentsReady(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).numAgentsReady;
    }

    return retVal;
}

export function EDQueueGetNumAgentsNotReady(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).numAgentsNotReady;
    }

    return retVal;
}

export function EDQueueGetNumAgentsBusy(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).numAgentsBusy;
    }

    return retVal;
}

export function EDQueueGetNumAgentsWrap(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).numAgentsWrap;
    }

    return retVal;
}

export function EDQueueGetNumAgentsLoggedIn(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).numAgentsReady + vQueueMapV.get(queueId).numAgentsNotReady + vQueueMapV.get(queueId).numAgentsBusy + vQueueMapV.get(queueId).numAgentsWrap + vQueueMapV.get(queueId).numAgentsPaused;
    }

    return retVal;
}

export function EDQueueGetAvgHandleTime(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        var theQ = vQueueMapV.get(queueId);
        if (theQ.numContactsHandled <= 0 || theQ.totalHandleTime <= 0) {
            retVal = 0;
        }
        else {
            retVal = theQ.totalHandleTime / theQ.numContactsHandled;
            retVal = Number.parseFloat(retVal).toFixed(0);
        }        
    }

    return EDMakeTimeString(retVal);;
}

export function EDQueueGetAbandonmentRate(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        var theQ = vQueueMapV.get(queueId);
        if (theQ.numContactsHandled <= 0 || theQ.numContactsAbandoned <= 0) {
            retVal = 0;
        }
        else {
            retVal = (theQ.numContactsAbandoned / (theQ.numContactsHandled + theQ.numContactsAbandoned)) * 100;
            retVal = Number.parseFloat(retVal).toFixed(0);
        }
    }

    return retVal;
}

export function EDQueueGetNumContactsHandled(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).numContactsHandled;
    }

    return retVal;
}

export function EDQueueGetNumAgentsPaused(vQueueMapV, queueId) {
    var retVal = 0;

    if (vQueueMapV.has(queueId)) {
        retVal = vQueueMapV.get(queueId).numAgentsPaused;
    }

    return retVal;
}

export function EDQueueGetAgentsData(vQueueMapV, queueId, dbOptions) {
    var agentStatus = [{
        category: 'Ready',
        value: 0,
        color: EDGetStatusColor(dbOptions, 'Ready')
    }, {
        category: 'Not Ready',
        value: 0,
        color: EDGetStatusColor(dbOptions, 'NotReady')
    }, {
        category: 'Busy',
        value: 0,
        color: EDGetStatusColor(dbOptions, 'Busy')
    }, {
        category: 'Wrap-up',
        value: 0,
        color: EDGetStatusColor(dbOptions, 'Wrapup')
        }, {
            category: 'Presence',
            value: 0,
            color: EDGetStatusColor(dbOptions, 'Paused')
        } ];

    if (vQueueMapV.has(queueId)) {
        agentStatus[0].value = vQueueMapV.get(queueId).numAgentsReady;
        agentStatus[1].value = vQueueMapV.get(queueId).numAgentsNotReady;
        agentStatus[2].value = vQueueMapV.get(queueId).numAgentsBusy;
        agentStatus[3].value = vQueueMapV.get(queueId).numAgentsWrap;
        agentStatus[4].value = vQueueMapV.get(queueId).numAgentsPaused;
    }
    return agentStatus;
}

export function EDProcessQueueStatisticV(vQueueMapV, queueStatistic) {
    var idx = 0;
    for (idx = 0; idx < queueStatistic.length; idx++) {
        var currQueue = queueStatistic[idx];
        if (vQueueMapV.has(currQueue.queueId)) {
            // exists as part of a vQueue
            // TODO: add the bility to increase with +=
            var queueEntry = vQueueMapV.get(currQueue.queueId);
            if (queueEntry.isVirtual === true) {
                //console.log("PROC_QUEUE [BEFORE]: " + currQueue.queueId + ", numContactsHandled: " + vQueueEntry.numContactsHandled + ", countOfHandledContacts: " + currQueue.countOfHandledContacts);
                var vQueueEntry = vQueueMapV.get(queueEntry.id);
                vQueueEntry.numContactsHandled = currQueue.countOfHandledContacts;
                vQueueEntry.numContactsAbandoned = currQueue.countOfAbandonedContacts;
                var duration = 0;
                if (currQueue.handlingDuration >= 1000)
                    duration = currQueue.handlingDuration / 1000; // val in MS
                vQueueEntry.totalHandleTime = duration;    
               // console.log("PROC_QUEUE [AFTER]: " + currQueue.queueId + ", numContactsHandled: " + vQueueEntry.numContactsHandled + ", countOfHandledContacts: " + currQueue.countOfHandledContacts);
                vQueueMapV.set(currQueue.id, vQueueEntry);
            }
        }
    }
    return vQueueMapV;
}

export function EDProcessQueueStatusV(vQueueMapV, queueStatus) {
    var idx = 0;
    for (idx = 0; idx < queueStatus.length; idx++) {
        var currQueue = queueStatus[idx];
        if (vQueueMapV.has(currQueue.id)) {
            // exists as part of a vQueue
            var queueEntry = vQueueMapV.get(currQueue.id);
            if (queueEntry.isVirtual === true) {
                var vQueueEntry = vQueueMapV.get(queueEntry.id);
                vQueueEntry.numInQueue += currQueue.inQueueCurrent;
                if (currQueue.waitingDurationCurrentMax >= 1000) {
                    vQueueEntry.longestWaitingInSeconds += (currQueue.waitingDurationCurrentMax / 1000);
                }
                vQueueEntry.numAgentsReady += currQueue.agentsFree;
                vQueueEntry.numAgentsNotReady += currQueue.agentsNotReady;
                vQueueEntry.numAgentsWrap += currQueue.agentsWrapUp;
                vQueueEntry.numAgentsPaused += currQueue.agentsPause;
                vQueueEntry.numAgentsBusy += currQueue.agentsBusy;
                vQueueEntry.numAgentsLoggedIn += currQueue.agentsServing;
                
                vQueueMapV.set(currQueue.id, vQueueEntry);
            }
        }
    }
    return vQueueMapV;
}


export function EDAgentGetAvgHandleTime(currAgent) {
    var retVal = 0;

    if (currAgent.totalHandleTimeCallsIn > 0 && currAgent.numCallsHandledIn > 0) {
        retVal = currAgent.totalHandleTimeCallsIn / currAgent.numCallsHandledIn;
        retVal = Number.parseFloat(retVal).toFixed(0);
        retVal = EDMakeTimeString(retVal);
    }
    return retVal;

}
export function EDProcessAgentUserStatistics(agentMapV, userStatistics) {
    var idx = 0; 
    for (idx = 0; idx < userStatistics.length; idx++) {
        var currUserStat = userStatistics[idx];
        if (currUserStat.hasOwnProperty('userId')) {
            if (agentMapV.has(currUserStat.userId)) {
                var agentEntry = agentMapV.get(currUserStat.userId);
                EDLogObj('EDProcessAgentUserStatistics: Found: ' + currUserStat.userId, agentEntry);
                if (currUserStat.channel === 'Phone' && currUserStat.type === 'CallIn') {
                    agentEntry.numCallsOffered = currUserStat.countOfHandledContacts + currUserStat.countOfFalseAttemptContacts + currUserStat.countOfAbandonedContacts;
                    agentEntry.numCallsHandledIn = currUserStat.countOfHandledContacts;
                    agentEntry.totalHandleTimeCallsIn = currUserStat.handlingDuration;
                    if (agentEntry.totalHandleTimeCallsIn >= 1000)
                        agentEntry.totalHandleTimeCallsIn /= 1000;
                }
                else if (currUserStat.channel === 'Phone' && currUserStat.type === 'CallOut') {
                    agentEntry.numCallsHandledOut = currUserStat.countOfHandledContacts;
                    agentEntry.totalHandleTimeCallsOut = currUserStat.handlingDuration;
                    if (agentEntry.totalHandleTimeCallsOut >= 1000)
                        agentEntry.totalHandleTimeCallsOut /= 1000;
                }
                else if (currUserStat.channel === 'Email' && currUserStat.type === 'EmailOut') {
                    agentEntry.numEmailsOut = currUserStat.countOfHandledContacts;
                }
                else if (currUserStat.channel === 'Email' && currUserStat.type === 'EmailIn') {
                    agentEntry.numEmailsOffered = currUserStat.countOfHandledContacts + currUserStat.countOfFalseAttemptContacts + currUserStat.countOfAbandonedContacts;
                    agentEntry.numEmailsHandled = currUserStat.countOfHandledContacts;
                }
                        
                agentMapV = agentMapV.set(currUserStat.userId, agentEntry);
            }
        }       
    }
    return agentMapV;
}

export function EDProcessAgentUserStatisticsDay(agentMapV, userStatisticsDay) {
    var idx = 0;
    for (idx = 0; idx < userStatisticsDay.length; idx++) {
        var currUserStat = userStatisticsDay[idx];
        if (currUserStat.hasOwnProperty('userId')) {
            if (agentMapV.has(currUserStat.userId)) {
                var agentEntry = agentMapV.get(currUserStat.userId);

                agentEntry.totalServingTime = currUserStat.servingDuration;
                if (agentEntry.totalServingTime >= 1000)
                    agentEntry.totalServingTime /= 1000;
                agentEntry.totalWorkingTime = currUserStat.readyDuration;
                if (agentEntry.totalWorkingTime >= 1000)
                    agentEntry.totalWorkingTime /= 1000;

                if (agentEntry.totalServingTime > 0 && agentEntry.totalWorkingTime > 0) {
                    agentEntry.utilizationPct = (agentEntry.totalWorkingTime / agentEntry.totalServingTime) * 100;
                    agentEntry.utilizationPct = Number.parseFloat(agentEntry.utilizationPct).toFixed(0);
                }
                agentMapV = agentMapV.set(currUserStat.userId, agentEntry);
            }
        }
    }
    return agentMapV;
}

export function EDProcessAgentUserStatus(agentMapV, userStatus) {
    var idx = 0;
    for (idx = 0; idx < userStatus.length; idx++) {
        var currUserStat = userStatus[idx];
        if (currUserStat.hasOwnProperty('id')) {
            if (agentMapV.has(currUserStat.id)) {
                var agentEntry = agentMapV.get(currUserStat.id);
                EDLogObj('EDProcessAgentUserStatus: Found: ' + currUserStat.id, agentEntry);
                agentEntry.status = currUserStat.status;
                agentEntry.presenceProfile = currUserStat.presenceName;
                if (agentEntry.status === 'Ready') {
                    if (currUserStat.activeIbCallCnt > 0 ||
                        currUserStat.activeIbChatCnt > 0 ||
                        currUserStat.activeIbEmailCnt > 0 ||
                        currUserStat.activeIbOperDirCallCnt > 0 ||
                        currUserStat.activeIbVideoChatCnt > 0 ||
                        currUserStat.activeObCallCnt > 0 ||
                        currUserStat.activeObCampaignCallCnt > 0 ||
                        currUserStat.activeObCbrCallCnt > 0 ||
                        currUserStat.activeObEmailCnt > 0) {
                        agentEntry.status = 'Busy';
                        }
                }
                agentMapV = agentMapV.set(currUserStat.id, agentEntry);
            }
        }
    }
    return agentMapV;
}

export function EDResetQueueData(queueV) {
    queueV.numInQueue = 0;
    queueV.longestWaitingInSeconds = 0;
    queueV.numAgentsReady = 0;
    queueV.numAgentsNotReady = 0;
    queueV.numAgentsBusy = 0;
    queueV.numAgentsWrap = 0;
    queueV.numAgentsPaused = 0;
    queueV.numContactsHandled = 0;
    queueV.numAgentsLoggedIn = 0;
    queueV.numContactsAbandoned = 0;
    queueV.totalHandleTime = 0;
    queueV.avgHandleTime = 0;
    queueV.abandonmentRate = 0;
    return queueV;
}

export function EDMakeEmptyQueueData(isVirtual) {
    return {
        isVirtual: isVirtual,
        id: "Not synched",
        numInQueue: 0,
        longestWaitingInSeconds: 0,
        numAgentsReady: 0,
        numAgentsNotReady: 0,
        numAgentsBusy: 0,
        numAgentsWrap: 0,
        numAgentsPaused: 0,
        numContactsHandled: 0,
        numAgentsLoggedIn: 0,
        numContactsAbandoned: 0,
        totalHandleTime: 0,
        avgHandleTime: 0,
        abandonmentRate: 0,
        subscribeData: null
    };
}

export function EDResetAgentData(agentV) {
    agentV.statusDuration = 0;
    agentV.numCallsOffered = 0;
    agentV.numCallsHandledIn = 0;
    agentV.numCallsHandledOut = 0;
    agentV.numCallbacksOffered = 0;
    agentV.numCallbacksHandled = 0;
    agentV.numCallbacksOut = 0;
    agentV.numEmailsOffered = 0;
    agentV.numEmailsHandled = 0;
    agentV.numEmailsOut = 0;
    agentV.totalHandleTime = 0;
    agentV.totalHandleTimeCallsOut = 0;
    agentV.totalHandleTimeCallsIn = 0;
    agentV.totalHandleTimeCallbacks = 0;
    agentV.totalHandleTimeEmailIn = 0;
    agentV.totalHandleTimeEmailOut = 0;
    agentV.totalFreeTime = 0;
    agentV.totalServingTime = 0;
    agentV.totalWorkingTime = 0;
    agentV.utilizationPct = 0;
    return agentV;
}

export function EDMakeEmptyAgentData() {
    return {
        id: "Not synched",
        name: "Not synched",
        avatarName: "?",
        status: "Not synched",
        presenceProfile: "Not synched",
        statusDuration: 0,
        numCallsOffered: 0,
        numCallsHandledIn: 0,
        numCallsHandledOut: 0,
        numCallbacksOffered: 0,
        numCallbacksHandled: 0,
        numCallbacksOut: 0,
        numEmailsOffered: 0,
        numEmailsHandled: 0,
        numEmailsOut: 0,
        totalHandleTime: 0,
        totalHandleTimeCallsOut: 0,
        totalHandleTimeCallsIn: 0,
        totalHandleTimeCallbacks: 0, 
        totalHandleTimeEmailIn: 0,
        totalHandleTimeEmailOut: 0,
        totalFreeTime: 0,
        totalServingTime: 0,
        totalWorkingTime: 0,
        utilizationPct: 0,
        agentSubscribeData: null
    };
}

export function EDMakeTimeString(sec) {
    try {
        if (sec === 0)
            return "0";
        var hours = Math.floor(sec / 3600);
        var minutes = Math.floor((sec - (hours * 3600)) / 60);
        var seconds = Math.floor(sec - (hours * 3600) - (minutes * 60));
        

        // if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        if (hours === 0 && minutes === '00')
            return ':' + seconds;
        if (hours === 0)
            return minutes + ':' + seconds;
        if( hours < 24)
            return hours + ':' + minutes + ':' + seconds;

        var days = Math.floor(hours / 24);
        hours = Math.floor(hours - (days * 24));
        return days + "d " + hours + "h";
    }
    catch (e) {
        EDLog('EDMakeTimeString error converting: (' + sec + '). message: ' + e.Message);
    }
    return "0";
}


export function EDGetStatusColor(dbOptions, status) {
    var retVal = 'Black';
    switch (status) {
        case "NotReady":
            retVal = dbOptions.StatusNotReadyColor;
            break;
        case "Ready":
            retVal = dbOptions.StatusReadyColor;
            break;
        case "LoggedOut":
            retVal = dbOptions.StatusLoggedOutColor;
            break;
        case "Pause":
        case "Paused":
            retVal = dbOptions.StatusPresenceProfileColor;
            break;
        case "Wrapup":
            retVal = dbOptions.StatusWrapupColor;
            break; 
        case "Busy":
            retVal = dbOptions.StatusBusyColor;
            break; 
        default:
            retVal = 'Black';
    }
    return retVal;
}

export function EDMakeAvatarName(name) {
    var retVal = "?";
    try {
        var nameSplit = name.split(',');
        if (nameSplit.length !== 2) {
            EDLog('Unexpected format for name. Missing ,');
        }
        else {
            retVal = nameSplit[1].trim().charAt(0).toUpperCase() + nameSplit[0].trim().charAt(0).toUpperCase()
        }
    }
    catch (e) {
        EDLog('Unable to shorten name: (' + name +') err: ' + e.Message);
    }
    return retVal;
}

export function EDGetSortedArray(agentMapValues) {
    var retVal = []
    var idx = 0;
    for (idx = 0; idx < agentMapValues.length; idx++) {
        retVal.push(agentMapValues[idx]);
    }
    retVal.sort(function (val1, val2) {
        if (val1.status === 'Ready') {
            if (val2.status === 'Ready') {
                return (val1.name.toLowerCase() < val2.name.toLowerCase()) ? -1 : 1;
            }
            return -1;
        }
        if (val2.status === 'Ready') {
            return 1;
        }
        if (val1.status === 'Busy') {
            if (val2.status === 'Busy') {
                return (val1.name.toLowerCase() < val2.name.toLowerCase()) ? -1 : 1;
            }
            return -1;
        }
        if (val1.status === 'NotReady') {
            if (val2.status === 'NotReady') {
                return (val1.name.toLowerCase() < val2.name.toLowerCase()) ? -1 : 1;
            }
            if (val2.status === 'Busy') {
                return 1;
            }
            return -1;
        }
        if (val1.status === 'Pause' || val1.status === 'Paused') {
            if (val2.status === 'Pause' || val2.status === 'Paused') {
                return (val1.name.toLowerCase() < val2.name.toLowerCase()) ? -1 : 1;
            }   
            if (val2.status === 'Busy') {
                return 1;
            }
            if (val2.status === 'NotReady') {
                return 1;
            }
            return -1;
        }
        if (val1.status === 'LoggedOut') {
            if (val2.status === 'LoggedOut') {
                return (val1.name.toLowerCase() < val2.name.toLowerCase()) ? -1 : 1;
            }
            return 1;
        }
        return 1;
    });
    return retVal;
}
